import { useState, useMemo } from 'react';
import SortIcon from '../assets/sort.png'

const useTableSort = (data, initialSortConfig = null) => {
    const [sortConfig, setSortConfig] = useState(initialSortConfig);

    const sortedData = useMemo(() => {
        if (!sortConfig || !sortConfig.key) {
            return data;
        }

        const sortableData = [...data];
        sortableData.sort((a, b) => {
            const aValue = getNestedValue(a, sortConfig.key);
            const bValue = getNestedValue(b, sortConfig.key);

            // Handle null/undefined values
            if (aValue === null || aValue === undefined) return 1;
            if (bValue === null || bValue === undefined) return -1;

            // Handle different data types
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                const comparison = aValue.localeCompare(bValue, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
                return sortConfig.direction === 'ascending' ? comparison : -comparison;
            }

            if (typeof aValue === 'number' && typeof bValue === 'number') {
                const comparison = aValue - bValue;
                return sortConfig.direction === 'ascending' ? comparison : -comparison;
            }

            // Handle dates (assumes ISO string format or Date objects)
            const aDate = new Date(aValue);
            const bDate = new Date(bValue);
            if (!isNaN(aDate.getTime()) && !isNaN(bDate.getTime())) {
                const comparison = aDate.getTime() - bDate.getTime();
                return sortConfig.direction === 'ascending' ? comparison : -comparison;
            }

            // Fallback to string comparison
            const comparison = String(aValue).localeCompare(String(bValue), undefined, {
                numeric: true,
                sensitivity: 'base'
            });
            return sortConfig.direction === 'ascending' ? comparison : -comparison;
        });

        return sortableData;
    }, [data, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (columnKey) => {
        if (!sortConfig || sortConfig.key !== columnKey) {
            // return '↕️'; // Both arrows when not sorted
            return <img src={SortIcon} style={{ width: '16px', height: '16px' }} />; // Both arrows when not sorted
        }
        // return sortConfig.direction === 'ascending' ? '↑' : '↓';
        return <img src={SortIcon} style={{ width: '16px', height: '16px' }} />; // Both arrows when not sorted
    };

    const getSortableHeaderProps = (columnKey) => ({
        onClick: () => requestSort(columnKey),
        style: {
            cursor: 'pointer',
            userSelect: 'none',
            position: 'relative'
        },
        className: 'sortable-header'
    });

    return {
        sortedData,
        requestSort,
        sortConfig,
        getSortIcon,
        getSortableHeaderProps
    };
};

// Helper function to get nested object values (e.g., 'user.name')
const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => current?.[key], obj);
};

export default useTableSort;